'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SingleSelect = require('./SingleSelect');

Object.defineProperty(exports, 'SingleSelect', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SingleSelect).default;
  }
});

var _MultiSelect = require('./MultiSelect');

Object.defineProperty(exports, 'MultiSelect', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MultiSelect).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/index.js
// module id = 557
// module chunks = 0